import {patchState, signalStore, withComputed, withMethods, withProps, withState} from '@ngrx/signals';
import {removeAllEntities, removeEntity, setAllEntities, setEntity, withEntities} from '@ngrx/signals/entities';
import {FixedSamplePoint} from 'src/app/infrastructure/moovement-api/models/asset';
import {DeviceAssociationStore} from 'src/app/domain/devices/device-association.store';
import {computed, inject} from '@angular/core';
import {DeviceStore} from 'src/app/domain/devices/device.store';

const initialState = {
  _loadingFixedSamplePoints: true
};

export const FixedSamplePointsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withEntities<FixedSamplePoint>(),
  withProps(() => {
    return {
      deviceStore: inject(DeviceStore),
      deviceAssociationStore: inject(DeviceAssociationStore)
    };
  }),
  withMethods((store) => ({
    setAllEntities(fixedSamplePoints: FixedSamplePoint[]) {
      patchState(store, setAllEntities(fixedSamplePoints), { _loadingFixedSamplePoints: false });
    },
    setEntity(fixedSamplePoints: FixedSamplePoint) {
      patchState(store, setEntity(fixedSamplePoints))
    },
    removeEntity(id: string) {
      patchState(store, removeEntity(id))
    },
    reset() {
      patchState(store, removeAllEntities(), initialState);
    }
  })),
  withComputed(({ _loadingFixedSamplePoints, deviceAssociationStore, deviceStore }) => ({
    loading: computed(() => {
      return _loadingFixedSamplePoints() || deviceAssociationStore.loading() || deviceStore.loading();
    })
  })),
  withComputed(({ loading, deviceAssociationStore, deviceStore, entities }) => ({
    proximitySamplePoints: computed(() => {
      if (loading()) return [];

      const devices = deviceStore.proximityDevices();
      const assetIds = new Set(devices
        .map(device => deviceAssociationStore.deviceIdToAssetId().get(device.id))
        .filter(assetId => assetId !== undefined));
      const proximitySamplePoints = entities().filter(fixedSamplePoint => assetIds.has(fixedSamplePoint.id));

      return proximitySamplePoints;
    }),
    precipitationSamplePoints: computed(() => {
      if (loading()) return [];

      const devices = deviceStore.precipitationDevices();
      const assetIds = new Set(devices
        .map(device => deviceAssociationStore.deviceIdToAssetId().get(device.id))
        .filter(assetId => assetId !== undefined));
      const precipitationSamplePoints = entities().filter(fixedSamplePoint => assetIds.has(fixedSamplePoint.id));

      return precipitationSamplePoints;
    })
  })),
  withComputed(({ proximitySamplePoints, precipitationSamplePoints }) => ({
    proximitySamplePointsById: computed(() => {
      const result = new Map<string, FixedSamplePoint>();
      proximitySamplePoints().forEach(samplePoint => {
        result.set(samplePoint.id, samplePoint);
      });

      return result;
    }),
    precipitationSamplePointsById: computed(() => {
      const result = new Map<string, FixedSamplePoint>();
      precipitationSamplePoints().forEach(samplePoint => {
        result.set(samplePoint.id, samplePoint);
      });

      return result;
    })
  }))
);
